import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { dataProfessionals, dataEnterprises } from '../../../dummyData'
import style from './WhyChimp.module.css'

const TABS = [
  { key: 'Personal', label: 'For Professionals' },
  { key: 'Enterprises', label: 'For Enterprises' },
]

const CheckIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <circle cx="11" cy="11" r="11" fill="rgba(67,44,91,0.1)" />
    <path d="M6.5 11.5L9.5 14.5L15.5 8" stroke="#432C5B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const CrossIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
    <circle cx="11" cy="11" r="11" fill="rgba(0,0,0,0.04)" />
    <path d="M7.5 7.5L14.5 14.5M14.5 7.5L7.5 14.5" stroke="rgba(37,20,54,0.25)" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

const rowVariants = {
  hidden: { opacity: 0, x: -16 },
  show: (i) => ({
    opacity: 1,
    x: 0,
    transition: { duration: 0.32, delay: i * 0.07, ease: 'easeOut' },
  }),
  exit: { opacity: 0, x: 12, transition: { duration: 0.15 } },
}

const WhyChimp = () => {
  const [tab, setTab] = useState('Personal')
  const data = tab === 'Personal' ? dataProfessionals : dataEnterprises

  return (
    <section className={style.section}>
      <motion.div
        className={style.header}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.55 }}
      >
        <span className={style.eyebrow}>Why Chimp?</span>
        <h2 className={style.title}>Built different. Proven better.</h2>
        <p className={style.subtitle}>
          See how Chimp compares to everything else out there.
        </p>
      </motion.div>

      {/* Sliding pill toggle */}
      <div className={style.toggleWrap}>
        <div className={style.toggle}>
          {TABS.map(({ key, label }) => (
            <button key={key} className={style.toggleBtn} onClick={() => setTab(key)}>
              {tab === key && (
                <motion.span
                  layoutId="pill"
                  className={style.pill}
                  transition={{ type: 'spring', stiffness: 380, damping: 30 }}
                />
              )}
              <span className={`${style.toggleLabel} ${tab === key ? style.toggleLabelActive : ''}`}>
                {label}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Comparison card */}
      <motion.div
        className={style.card}
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className={style.cardHead}>
          <span className={style.colFeature}>Feature</span>
          <span className={style.colChimp}>Chimp</span>
          <span className={style.colOthers}>Others</span>
        </div>

        <AnimatePresence mode="wait">
          <motion.div key={tab} className={style.rows}>
            {data.map((item, i) => (
              <motion.div
                key={item.id}
                className={style.row}
                custom={i}
                variants={rowVariants}
                initial="hidden"
                animate="show"
                exit="exit"
              >
                <span className={style.rowLabel}>{item.title}</span>
                <span className={style.rowChimp}>
                  <CheckIcon />
                </span>
                <span className={style.rowOthers}>
                  {item.others === 'limited' ? (
                    <span className={style.limited}>Limited</span>
                  ) : (
                    <CrossIcon />
                  )}
                </span>
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </motion.div>
    </section>
  )
}

export default WhyChimp
